import React from 'react';
import { PageStyle } from '../Utils/generalStyles';

// Components
import GalleryDetails from '../Components/GalleryDetails';
import GalleryIconDetails from '../Components/GalleryDetails/IconDetails';
import FooterSection from '../Components/Footer';

const galleryDetails = () => (
  <PageStyle>
    <GalleryDetails />
    <GalleryIconDetails />
    <FooterSection />
  </PageStyle>
);

export default galleryDetails;
